import { render } from "./ConfigUserScreen.vue?vue&type=template&id=9e0f8efa"
import script from "./ConfigUserScreen.vue?vue&type=script&lang=ts"
export * from "./ConfigUserScreen.vue?vue&type=script&lang=ts"
script.render = render

export default script